import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { Box, Grid, Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(10, 0)
    },
    comp: {
      maxWidth: theme.spacing(46.875)
    },
    image: {
      maxHeight: theme.spacing(8)
    },
    subtitle: {
      width: "100%",
      height: theme.spacing(2.25),
      marginBottom: theme.spacing(1)
    },
    susbtitleColor: {
      color: theme.palette.text.medium
    },
    title: {
      width: "100%",
      height: theme.spacing(8.75),
      marginBottom: theme.spacing(3)
    },
    listOuter: {
      marginBottom: theme.spacing(2)
    },
    list: _defineProperty({
      paddingLeft: theme.spacing(2)
    }, theme.breakpoints.down("xs"), {
      paddingLeft: theme.spacing(4)
    }),
    litem: {
      "&::marker": {
        fontSize: theme.spacing(2.5)
      }
    },
    litemText: {
      marginBottom: theme.spacing(1)
    },
    btnOuter: {
      width: "100%"
    }
  };
});
var TitleListCta = function TitleListCta(_ref) {
  var _BUTTON_TYPES$cta$typ, _BUTTON_TYPES$cta$typ2;
  var bgColor = _ref.bgColor,
    title = _ref.title,
    subtitle = _ref.subtitle,
    image = _ref.image,
    textLines = _ref.textLines,
    cta = _ref.cta,
    footnote = _ref.footnote;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.root,
    container: true,
    alignItems: "center",
    justify: "center",
    direction: "row"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    container: true,
    alignItems: "center",
    direction: "column",
    justify: "space-between",
    className: classes.comp
  }, (image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(image === null || image === void 0 ? void 0 : image.url, {
      width: 120,
      height: 120
    }),
    alt: image === null || image === void 0 ? void 0 : image.alt
  })), subtitle && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.subtitle
  }, /*#__PURE__*/React__default.createElement(Typography, {
    align: "center",
    variant: "subtitle2",
    component: "div",
    className: classes.susbtitleColor
  }, subtitle)), title && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.title
  }, /*#__PURE__*/React__default.createElement(Typography, {
    align: "center",
    variant: "h3",
    component: "h2"
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.listOuter
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: classes.list
  }, (textLines === null || textLines === void 0 ? void 0 : textLines.length) > 0 && textLines.map(function (txtitem, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: index,
      className: classes.litem
    }, /*#__PURE__*/React__default.createElement(Typography, {
      className: classes.litemText,
      variant: "body1"
    }, txtitem));
  }))), cta && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes === null || classes === void 0 ? void 0 : classes.btnOuter
  }, /*#__PURE__*/React__default.createElement(CustomButton, {
    fullWidth: true,
    variant: (_BUTTON_TYPES$cta$typ = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ === void 0 ? void 0 : _BUTTON_TYPES$cta$typ.variant,
    color: (_BUTTON_TYPES$cta$typ2 = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ2 === void 0 ? void 0 : _BUTTON_TYPES$cta$typ2.color,
    href: cta === null || cta === void 0 ? void 0 : cta.url
  }, cta === null || cta === void 0 ? void 0 : cta.label)), footnote && footnote.trim() !== "" && /*#__PURE__*/React__default.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, footnote)))));
};
TitleListCta.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  image: PropTypes__default.object,
  textLines: PropTypes__default.array,
  cta: PropTypes__default.object,
  footnote: PropTypes__default.string
};

export { TitleListCta as default };
//# sourceMappingURL=TitleListCta.js.map
